<template>
  <vs-table :data="data" class="w-full">
    <template slot="header">
      <vs-row>
        <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="px-2 mb-2">
          <add-vendor class="mt-4" @success="refresh" />
        </vs-col>

        <vs-col vs-xs="12" vs-sm="10" vs-lg="10" style="display: inline-flex">
          <div class="con-input-search vs-table--search">
            <input
              class="input-search vs-table--search-input"
              type="text"
              v-model="text"
              @keyup="search"
            />
            <vs-icon icon="search"></vs-icon>
          </div>
        </vs-col>
      </vs-row>
    </template>
    <template slot="thead">
      <th-sort
        :text="$tc('vendor') | capitalize"
        column="Vendors.Name"
        @sort="handleClickSort"
        width="700px"
      />
      <th-sort
        :text="$t('rfc')"
        column="Vendors.RFC"
        @sort="handleClickSort"
        width="100px"
      />
      <vs-th></vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ data[i].VendorName }}
        </vs-td>
        <vs-td>
          {{ data[i].RFC }}
        </vs-td>

        <vs-td style="float: right">
          <action-icon
            icon="ArrowRightCircleIcon"
            :tooltip="$t('details')"
            v-if="hasPermission(['IU VENDORS EDIT'])"
            @click="showDetails(data[i].VendorId)"
          />
          <!-- <action-icon
            icon="TrashIcon"
            :tooltip="$t('delete')"
            v-if="hasPermission(['IU VENDORS DELETE'])"
          /> -->
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import AddVendor from './AddVendor.vue'
export default {
  components: {
    AddVendor,
    ActionIcon,
    ThSort,
  },
  data() {
    return {
      text: '',
    }
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      if (this.text.length >= 3 || this.text.length == 0) {
        this.$emit('search', this.text)
      }
      return
    },
    refresh() {
      this.$emit('refresh')
    },
    showDetails(id) {
      this.$emit('showDetails', id)
    },
    handleClickSort(event) {
      this.$emit('sort', event)
    },
    confirmDelete(vendor) {
      this.vendorData = Object.assign({}, vendor)
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm,
        text: this.$i18n.messages[this.$i18n.locale].confirm_message,
        acceptText: this.$i18n.messages[this.$i18n.locale].delete,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.delete,
      })
    },
  },
}
</script>

<style>
</style>